export function desktopEditingAllowed(
  navigatorValue = navigator,
  screenValue = screen,
  coarsePointer = window.matchMedia('(pointer: coarse)').matches,
): boolean {
  const mobile = /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(navigatorValue.userAgent);
  const ipadDesktop = navigatorValue.platform === 'MacIntel' && navigatorValue.maxTouchPoints > 1;
  const touchTablet =
    coarsePointer &&
    navigatorValue.maxTouchPoints > 1 &&
    Math.min(screenValue.width, screenValue.height) <= 1024;
  return !(mobile || ipadDesktop || touchTablet);
}

export function renderDesktopRequired(siteId?: string, preview = false): void {
  document.documentElement.removeAttribute('data-app-booting');
  if (preview && siteId) {
    document.body.innerHTML = `<main class="mobile-draft-preview"><header><a class="cloud-brand" href="/dashboard?section=websites">WEBKILN</a><span>Saved draft · read only</span><a class="ghost-btn" href="/dashboard?section=websites">Back to websites</a></header><iframe title="Saved draft preview" sandbox="" src="/api/sites/${encodeURIComponent(siteId)}/thumbnail"></iframe></main>`;
    return;
  }
  document.body.innerHTML = `<main class="cloud-app auth-app"><section class="auth-card"><a class="cloud-brand" href="/dashboard">WEBKILN</a><p class="eyebrow">Desktop editor</p><h1>Build on a desktop.</h1><p>Website editing requires a desktop or laptop. Open this website on your computer to continue. You can still manage your workspace and view live websites here.</p><a class="primary-btn" href="/dashboard?section=websites">Back to websites</a>${siteId ? `<a class="ghost-btn" href="/editor/${encodeURIComponent(siteId)}?preview=1">Preview saved draft</a>` : ''}</section></main>`;
}
